export enum ActivityFilterGrade {
    Default = 0,
    Graded = 1,
    NotGraded = 2,
}
